(function () {
  'use strict';

  const STYLE_ID = 'tp-size-finder-focus-fix-styles';
  const SUPPRESS_MS = 240;

  let suppressUntil = 0;
  let savedDialogScroll = 0;
  let savedWindowX = 0;
  let savedWindowY = 0;
  let lastControl = null;

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      @media (max-width: 767px) {
        .tp-size-finder__input {
          font-size: 16px !important;
        }
        .tp-size-finder__dialog {
          -webkit-text-size-adjust: 100%;
          overscroll-behavior: contain;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function markNoAutoFocus(event) {
    const target = event.target instanceof Element
      ? event.target.closest('.tp-size-finder__unit, .tp-size-guide-trigger')
      : null;

    if (!target) return;

    suppressUntil = performance.now() + SUPPRESS_MS;
    savedWindowX = window.scrollX || 0;
    savedWindowY = window.scrollY || 0;
    lastControl = target;

    const modal = target.closest('.tp-size-finder');
    const dialog = modal ? modal.querySelector('.tp-size-finder__dialog') : null;
    savedDialogScroll = dialog ? dialog.scrollTop : 0;
  }

  document.addEventListener('pointerdown', markNoAutoFocus, true);
  document.addEventListener('click', markNoAutoFocus, true);

  document.addEventListener('focusin', function (event) {
    const input = event.target instanceof Element
      ? event.target.closest('.tp-size-finder__input')
      : null;

    if (!input || performance.now() > suppressUntil) return;

    const dialog = input.closest('.tp-size-finder__dialog');
    const control = lastControl;

    requestAnimationFrame(function () {
      if (document.activeElement === input) input.blur();

      if (dialog) dialog.scrollTop = savedDialogScroll;
      window.scrollTo(savedWindowX, savedWindowY);

      try {
        if (control && control.classList.contains('tp-size-finder__unit')) {
          control.focus({ preventScroll: true });
        } else if (dialog) {
          dialog.focus({ preventScroll: true });
        }
      } catch (error) {}
    });
  }, true);

  addStyles();
})();
